//-import Lenis from 'lenis'
import { object } from './_obj.js';
let Block = {
	top: 0,
	show: 0
}
let blocks = [];
/*
座標
elem.getBoundingClientRect()
*/
let $this;
export class Scroll {
	constructor(){
		$this = this;
		this.topD = 0;
		this.btmD = this.topD + window.innerHeight;
		this.animations = new Array();
		this.blocks 	= new Array();
		this.observer;
		this.blockObserver;
		//-this.lenis = new Lenis();
		this.check();
		this.reloadObserver();
		
		//-this.startLenis();
		document.addEventListener("scroll", ()=>{
			$this.topD = window.pageYOffset;
			$this.checkBlock();
		}, false);
	}
	startLenis(){
		let $this = this;
		$this.lenis.on('scroll', (e) => {
			//console.log(e)
			
		});
		function raf(time) {
			$this.lenis.raf(time)
			requestAnimationFrame(raf)
		}
		
		requestAnimationFrame(raf)
	}
	reloadObserver(){
		let $this = this;
		if($this.observer){
			$this.observer.disconnect();
		}
		this.setObserver(null);
	}
	
	setObserver(root){
		let $this = this;
		let $animates = document.querySelectorAll("[data-animate]");
		if( $animates ){
			//DOMにdata-repeat="1"で画面外にいったときにanimateのclassを削除
			let AnimateOptions = {
				root: root ? root : null,
				rootMargin: "-33% 0px",
				threshold: 0
			}
			//data-animate用observer
			$this.observer = new IntersectionObserver($this.checkAnimate, AnimateOptions);
			//console.log($animates, AnimateOptions, $this.observer);
			$animates.forEach( item => {
				$this.observer.observe(item);
			});
		}
		
		
		//other observer
		/*
		const elements = document.querySelectorAll('.watch-elements');
		
		// 要素ごとに異なる rootMargin を設定して監視
		elements.forEach((element, index) => {
		  // rootMargin を要素ごとに設定
		  let rootMarginValue;
		  if (index % 2 === 0) {
			rootMarginValue = '10px';
		  } else {
			rootMarginValue = '20px';
		  }
		
		  // Intersection Observer インスタンスを作成
		  const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
			  if (entry.isIntersecting) {
				console.log(`Element ${entry.target.id} is in view!`);
			  }
			});
		  }, { rootMargin: rootMarginValue });
		
		  // 要素を監視
		  observer.observe(element);
		});
		*/
	}
	check(){
		let $blocks = document.querySelectorAll("[data-block]");
		blocks = [];
		$blocks.forEach( ( $b ) => {
			let _b = object(Block);
			_b.top = Math.floor( $b.getBoundingClientRect().top + window.pageYOffset );
			_b.height = $b.clientHeight;
			blocks.push(_b);
		});
		//console.log(blocks);
	}
	checkBlock(){
		let $this = this;
		$this.topD = window.pageYOffset;
		for(let i = 0; i < blocks.length; i++){
			if( i === blocks.length - 1){
				if( $this.topD >= blocks[i].top ){
					$this.activeBlock(i);
				}
			}else{
				if( $this.topD >= blocks[i].top && $this.topD < blocks[i + 1].top ){
					$this.activeBlock(i);
				}
			}
		}
		let $html = document.documentElement;
		if( $this.topD < blocks[0].top ){
			let $blocks = document.querySelectorAll("[data-block]");
			$blocks.forEach( ( $b, index ) => {
				if( $b.classList.contains("active") ){
					$b.classList.remove("active");
				}
			});
			let $navs = document.querySelectorAll("#b-glbnav ul li a");
			$navs.forEach( ($n, index) => {
				if( $n.classList.contains("active") ){
					$n.classList.remove("active");
				}
			});
		}
		if( $this.topD < blocks[1].top ){
			if( $html.classList.contains("scrolled") ){
				$html.classList.remove("scrolled");
			}
		}else{
			if( !$html.classList.contains("scrolled") ){
				$html.classList.add("scrolled");
			}
		}
	}
	activeBlock(i){
		let $blocks = document.querySelectorAll("[data-block]");
		$blocks.forEach( ( $b, index ) => {
			if( index === i ){
				if( !$b.classList.contains("active") ){
					$b.classList.add("active");
				}
			}else{
				if( $b.classList.contains("active") ){
					$b.classList.remove("active");
				}
			}
		});
		let $navs = document.querySelectorAll("#b-glbnav ul li a");
		$navs.forEach( ($n, index) => {
			if( index === i ){
				$n.classList.add("active");
			}else{
				if( $n.classList.contains("active") ){
					$n.classList.remove("active");
				}
			}
		});
	}
	checkAnimate(items){
		items.forEach( (item) => {
			if( item.isIntersecting ){
				console.log("interSectiong:", item.target);
				startAnimate( item.target );
			}else{
				if( item.target.getAttribute("data-repeat") === "1" ){
					deleteAnimate(item.target);
				}
			}
		});
		
		function startAnimate( $target ){
			if( !$target.classList.contains("animate") ){
				$target.classList.add("animate");
			}
		}
		function deleteAnimate( $target ){
			if( $target.classList.contains("animate") ){
				$target.classList.remove("animate");
			}
		}
	}
	getTop($dom, offset){
		let t = Math.floor( $dom.getBoundingClientRect().top + window.pageYOffset );
		return [ t, Math.floor( t + offset )]
	}
	
	scrollToPos(posY){
		console.log("scroll to > ", posY);
		window.scrollTo({
			top: posY,
			behavior: "smooth"
		});
	}
}

export let ScrollTo = {
	begin: 0,
	yOffset: 0,
	end: 0,
	timer: null,
	start: function(y, duration){
		let $this = ScrollTo;
		$this.end = y;
		//console.log(y, duration);
		$this.begin = new Date() - 0;
		$this.yOffset = window.pageYOffset;
		//console.log($this.yOffset, y);
		
		clearInterval($this.timer);
		let ease = getEasing("easeInOutCubic");
		let max = y - window.pageYOffset;
		$this.timer = setInterval( ()=> {
			let current = new Date() - $this.begin;
			if(current >= duration){
				current = duration;
				clearInterval($this.timer);
			}
			//let progress = 1 - current/duration;
			let progress = current/duration;
			let easeProgress = ease(progress, 0, 1, 1);
			//console.log(easeProgress);
			let currentPos = max*easeProgress + $this.yOffset;
			//console.log(max*easeProgress, window.pageYOffset);
			window.scrollTo(0, currentPos );
		}, 33);
	}
}